import { render, staticRenderFns } from "./HealthRestart.vue?vue&type=template&id=484f2406&"
import script from "./HealthRestart.vue?vue&type=script&lang=js&"
export * from "./HealthRestart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports